import type { FunctionComponent } from "react";
import AddBrandManagerModalAdminPartial from "../../../../partials/admin/menus/campaign/add-brand-manager-modal.admin";

export const AddBrandManagerModalAdminScreen: FunctionComponent = () => {
    return <AddBrandManagerModalAdminPartial />;
};
